import React from 'react';
import { IPaymentDetailsProps } from '@components/Sura/PaymentDetails/types';
import useStyles from '@components/Sura/PaymentDetails/styles';
import { Typography } from '@material-ui/core';
import PAY_ON_LINE from '@assets/images/pay_on_line.png';
import { observer } from 'mobx-react';
import useStore from '@hooks/useStore';
import PolicyDetail from '@components/Sura/PaymentDetails/PolicyDetail';

const Contracts: React.FC<IPaymentDetailsProps> = () => {
  const { links, ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const contracts = links.paymentLink.sura.contracts;

  return (
    <div className={css.divContracts}>
      {contracts.map((contract, index) => (
        <PolicyDetail key={index} contract={contract} />
      ))}
      {!ui.isMobileScreen && (
        <div>
          <div className={css.divImg}>
            <img src={PAY_ON_LINE} alt="PaymentMethodIMG" />
          </div>
          <Typography className={css.labelSeguros}>
            Seguros <span className={css.labelSura}>SURA</span>{' '}
          </Typography>
          <Typography className={css.labelHashtag}>#AsegúratedeVivir</Typography>
        </div>
      )}
    </div>
  );
};

export default observer(Contracts);
